export default 
{
    "primary": [
            {
                "id": "prod_P2iEHuaJlboQ6r",
                "name": "Professional",
                "isPrimary": true,
                "prices": [
                    {
                        "id": "price_1OEcnbBr6gfOyd4MkoobMMwm",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "amount": 35.0
                    },
                    {
                        "id": "price_1OEcnbBr6gfOyd4MGSJ2mouA",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "amount": 350.0
                    }
                ]
            },
            {
                "id": "prod_P2ifYcgHeS61f8",
                "name": "Metered",
                "isPrimary": true,
                "interval": "record",
                "prices": [
                    {
                        "id": "price_1OEeNFBr6gfOyd4MU3PYTSkM",
                        "usageType": "metered",
                        "interval": "month",
                        "currency": "usd",
                        "amount": 0.0001
                    },
                ]
            },
            {
                "id": "prod_P2if4Ek3zDY54r",
                "name": "Corporate",
                "isPrimary": true,
                "prices": [
                    {
                        "id": "price_1OEdEKBr6gfOyd4MWIpqZ9XV",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "amount": 150.0
                    },
                    {
                        "id": "price_1OEdEKBr6gfOyd4MrVyUCcVs",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "amount": 1500.0
                    }
                ]
            },
            ,
		{
			"id": "prod_enterprise",
			"name": "Enterprise",
			"isPrimary": false,
			"isContactUs": true,
			"icon":"icon-enterprise.svg",
			"prices": [
				{
					"id": "subprod_enterprise1",
					"usageType": "licensed",
					"interval": "year",
					"currency": "eur",
					"label": "contactus"
				},
				{
					"id": "subprod_enterprise2",
					"usageType": "licensed",
					"interval": "year",
					"currency": "usd",
					"label": "contactus"
				},
				{
					"id": "subprod_enterprise3",
					"usageType": "licensed",
					"interval": "month",
					"currency": "eur",
					"label": "contactus"
				},
				{
					"id": "subprod_enterprise4",
					"usageType": "licensed",
					"interval": "month",
					"currency": "usd",
					"label": "contactus"
				}
			]
		},
    ],
    "primaryllx": [

        {
			"id": "prod_llxlevel1",
			"name": "Timeline LLC Level 1",
			"isPrimary": false,
			"isContactUs": false,
            "link": "/support/new-ticket/?type=Business+Enquiry&subject=Request+LLX+Level+1+Access",
            "buttonLabel": "messages.requesttrial",
			"icon":"icon-llxcore.svg",
			"prices": [
				 {
                        "id": "price_1OEdEKBr6gfOyd4MWIpqZ9XV_",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "amount": 99.0
                    },
                    {
                        "id": "price_1OEdEKBr6gfOyd4MWIpqZ9XV_",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "amount": 990.0
                    }
				
			]
		},
        


        {
			"id": "prod_llxlevel2",
			"name": "Timeline LLC Level 2  ",
			"isPrimary": true,
			"isContactUs": false,
            "link": "/support/new-ticket/?type=Business+Enquiry&subject=Request+LLX+Level+2+Access",
            "buttonLabel": "messages.requesttrial",
			"icon":"icon-llxpremier.svg",
			"prices": [
				 {
                        "id": "price_1OEdEKBr6gfOyd4MWIpqZ9XV__",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "amount": 299.0
                    },
                    {
                        "id": "price_1OEdEKBr6gfOyd4MWIpqZ9XV__",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "amount": 2990.0
                    }
			]
		},
        {
			"id": "prod_llxlevelenterprise",
			"name": "Timeline LLC Enterprise  ",
			"isPrimary": true,
			"isContactUs": true,
			"icon":"icon-llxultimate.svg",
			"prices": [
				 {
					"id": "subprod_enterprise1",
					"usageType": "licensed",
					"interval": "year",
					"currency": "eur",
					"label": "contactus"
				},
				{
					"id": "subprod_enterprise2",
					"usageType": "licensed",
					"interval": "year",
					"currency": "usd",
					"label": "contactus"
				},
				{
					"id": "subprod_enterprise3",
					"usageType": "licensed",
					"interval": "month",
					"currency": "eur",
					"label": "contactus"
				},
				{
					"id": "subprod_enterprise4",
					"usageType": "licensed",
					"interval": "month",
					"currency": "usd",
					"label": "contactus"
				}
			]
		},
        ],
        "addon": [
            {
                "id": "prod_NJWuAMntHzcYWM",
                "name": "Historical Forecast Data Add on",
                "isPrimary": false,
                "icon":"icon-historical-forecast-addon.svg",
                "prices": [
                    {
                        "id": "price_1PuxhFBr6gfOyd4MAZZNMDEM",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "amount": 165.0
                    },
                    {
                        "id": "price_1Qs9DmBr6gfOyd4MzCaLcFZB",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "amount": 1450
                    }
                ]
            },
            {
                "id": "prod_weathermaps",
                "name": "Weather Maps Addon",
                "isPrimary": false,
                "isContactUs": true,
                "icon":"icon-pricingmaps.svg",
                "prices": [
                    {
                        "id": "price_weathermaps1",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "eur",
                        "label": "comingsoon"
                    },
                    {
                        "id": "price_weathermaps2",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "label": "comingsoon"
                    },
                    {
                        "id": "price_weathermaps3",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "eur",
                        "label": "comingsoon"
                    },
                    {
                        "id": "price_weathermaps4",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "label": "comingsoon"
                    }
                ]
            },
            {
                "id": "prod_weatherStats",
                "name": "Weather Statistics",
                "isPrimary": false,
                "isContactUs": false,
                "link": "/resources/documentation/weather-data/introduction-to-weather-statistics-and-analysis/",
                "icon":"icon-weather-statistics.svg",
                "prices": [
                    {
                        "id": "price_weatherStats1",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "eur",
                        "label": "inpreview"
                    },
                    {
                        "id": "price_weatherStats2",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "label": "inpreview"
                    },
                    {
                        "id": "price_weatherStats3",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "eur",
                        "label": "inpreview"
                    },
                    {
                        "id": "price_weatherStats4",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "label": "inpreview"
                    }
                ]
            },
            {
                "id": "prod_loadingAccelerator",
                "name": "Loading Accelerator",
                "isPrimary": false,
                "isContactUs": true,
                "link": "/resources/documentation/weather-data/bulk-weather-data-in-visual-crossing/",
                "icon":"icon-dataaccelerator.svg",
                "prices": [
                    {
                        "id": "prod_loadingAccelerator",
                        "usageType": "licensed",
                        "interval": "month",
                        "currency": "usd",
                        "amount": 600.0
                    },
                    {
                        "id": "prod_loadingAccelerator_yearly",
                        "usageType": "licensed",
                        "interval": "year",
                        "currency": "usd",
                        "label": "contactus"
                    }
                ]
            },
        ]
};